import { RegionId } from "@sp-crm/core";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { createChangeRegionAction } from "store/actions/region";
import { useRegionId, useRegions } from "store/selectors/hooks";

export const useSwitchToRecordOffice = (recordRegionId: RegionId | null): void => {
    const selectedRegionId = useRegionId();
    const regions = useRegions();
    const dispatch = useDispatch();
    useEffect(() => {
        if (!selectedRegionId || !recordRegionId || recordRegionId === selectedRegionId) {
            return;
        }
        const recordOffice = regions.find(region => region.id === recordRegionId);
        if (recordOffice) {
            dispatch(createChangeRegionAction(recordOffice.key));
        }
    }, [dispatch, recordRegionId, regions, selectedRegionId]);
};
